import { PickersDay } from '@mui/x-date-pickers/PickersDay';

import { isPastMealDay } from '@/helper/mealDateOrderable';

/**
 * Calendar day that stays selectable for past dates but is visually marked
 * as view-only (orders cannot be placed).
 */
export default function PastAwarePickersDay(props) {
	const { day, outsideCurrentMonth, className, ...other } = props;
	const past = !outsideCurrentMonth && isPastMealDay(day);

	return (
		<PickersDay
			{...other}
			day={day}
			outsideCurrentMonth={outsideCurrentMonth}
			className={[className, past ? 'pickers-day-past-view-only' : null].filter(Boolean).join(' ')}
			title={past ? 'Past date — view orders only' : undefined}
		/>
	);
}
